import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth';
import LinkAccount from './pages/Link';
import Today from './pages/Today';
import Search from './pages/Search';
import BeneficiaryView from './pages/BeneficiaryView';
import VisitFlow from './pages/VisitFlow';
import MyCases from './pages/MyCases';
import CaseFlow from './pages/CaseFlow';

function NotLinked() {
  return (
    <div className="splash">
      <div style={{ fontSize: 44 }}>🔗</div>
      <h1 style={{ fontSize: 20, margin: 0 }}>ยังไม่ได้ผูกบัญชี</h1>
      <p className="muted">
        บัญชี LINE นี้ยังไม่ได้ผูกกับเจ้าหน้าที่คนใด
        <br />
        กรุณาขอลิงก์ผูกบัญชีจากผู้ดูแลระบบ แล้วเปิดลิงก์นั้นในแอป LINE
      </p>
    </div>
  );
}

function AuthError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="splash">
      <div style={{ fontSize: 44 }}>⚠️</div>
      <h1 style={{ fontSize: 20, margin: 0 }}>เข้าสู่ระบบไม่สำเร็จ</h1>
      <p className="muted">
        อาจเกิดจากสัญญาณอินเทอร์เน็ตไม่เสถียร
        <br />
        ลองใหม่อีกครั้ง หากยังไม่ได้ กรุณาติดต่อผู้ดูแลระบบ
      </p>
      <button onClick={onRetry}>ลองใหม่</button>
    </div>
  );
}

export default function App() {
  const { status, retry } = useAuth();
  const location = useLocation();

  // หน้าผูกบัญชีต้องเข้าถึงได้ก่อนยืนยันตัวตน — เพราะยังไม่มีบัญชีให้ยืนยัน
  const isLinkRoute = location.pathname.startsWith('/link');
  if (isLinkRoute) {
    return (
      <Routes>
        <Route path="/link" element={<LinkAccount />} />
      </Routes>
    );
  }

  if (status.kind === 'loading') return <div className="center">กำลังเข้าสู่ระบบ…</div>;
  if (status.kind === 'not_linked') return <NotLinked />;
  if (status.kind === 'error') return <AuthError onRetry={retry} />;

  return (
    <Routes>
      <Route path="/" element={<Today />} />
      <Route path="/today" element={<Today />} />
      <Route path="/search" element={<Search />} />
      <Route path="/beneficiary/:id" element={<BeneficiaryView />} />
      <Route path="/visit/:id" element={<VisitFlow />} />
      <Route path="/cases" element={<MyCases />} />
      <Route path="/case/:id" element={<CaseFlow />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
